// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__5X0Jp","bigColWidth":"Table_bigColWidth__DJsVW","biggerColWidth":"Table_biggerColWidth__38Hvm","row":"Table_row__1CS9E","col":"Table_col__2PqKF"};